// extracted by mini-css-extract-plugin
export default {"titleLine":"payment-details-title-line-fixed__titleLine___EhDAV","title":"payment-details-title-line-fixed__title___iDDA0"};